import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { MfWidgetLoader } from '@brandclub/common-ui';

/**
 * Test page for the Store Locator Widget (concierge-widgets MF version)
 * Access at: /store-locator-test
 *
 * Test SKU: 4223V7NE5
 */
const StoreLocatorTestPage: React.FC = () => {
  const testStacklineSku = '4223V7NE5';

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
          Store Locator Widget Test
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Testing the MF store-locator widget with stacklineSku: <strong>{testStacklineSku}</strong>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          This widget shows:
        </Typography>
        <ul style={{ marginTop: 8, paddingLeft: 24 }}>
          <li>
            <Typography variant="body2" color="text.secondary">
              <strong>Retailer Summary View:</strong> Grouped retailers with store counts
            </Typography>
          </li>
          <li>
            <Typography variant="body2" color="text.secondary">
              <strong>Store List View:</strong> Individual stores with "Details" buttons
            </Typography>
          </li>
          <li>
            <Typography variant="body2" color="text.secondary">
              <strong>Store Detail Panel:</strong> Hours, phone, holiday hours, and directions
            </Typography>
          </li>
        </ul>
      </Box>

      <Box sx={{
        border: '2px dashed #ccc',
        borderRadius: 2,
        p: 2,
        backgroundColor: '#fafafa',
      }}>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
          Widget rendered below:
        </Typography>
        <MfWidgetLoader
          widgetId="store-locator"
          toolInput={{ requestedLocation: undefined }}
          toolOutput={{ stacklineSkus: [testStacklineSku], hasStores: true }}
          partState="complete"
        />
      </Box>

      <Box sx={{ mt: 4, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
        <Typography variant="subtitle2" gutterBottom>
          Testing Notes:
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • Allow location access for best results
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • Click on retailer cards to see individual stores
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • Click "Details" to see store hours and contact info
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • Pan/zoom the map to load stores in different areas
        </Typography>
      </Box>
    </Container>
  );
};

export default StoreLocatorTestPage;


